var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 98,
    viewBox: "0 0 184 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.6874 3.2308C91.4621 3.2308 92.3608 2.7075 92.3836 1.6609V1.6154C92.3836 0.534674 91.4848 0 89.6874 0C64.8649 0 43.7282 4.76656 26.2774 14.2997C8.82651 23.8328 0.101074 37.0518 0.101074 53.9679C0.101074 66.5612 4.68566 76.902 13.8661 85.0018C23.0352 93.1015 36.8002 97.1514 55.1498 97.1514H65.9229C80.4956 97.1514 92.3836 85.2634 92.3836 70.6907V51.3401C92.3836 50.2138 93.305 49.2924 94.4313 49.2924H119.186C131.062 49.2924 139.776 50.6461 145.362 53.3423C150.936 56.0384 153.723 60.6229 153.723 67.1073C153.723 78.2558 148.502 85.5478 138.07 88.9606C127.638 92.3735 113.065 94.2619 94.363 94.6259C92.5883 94.6259 91.6896 95.1492 91.6669 96.1958V96.2413C91.6669 97.322 92.5656 97.8567 94.363 97.8567C119.186 97.8567 140.322 93.0901 157.773 83.557C175.224 74.0239 183.949 60.8049 183.949 43.8888C183.949 31.2955 179.365 20.9547 170.184 12.8549C161.015 4.75519 147.25 0.705315 128.901 0.705315H118.128C103.555 0.705315 94.4313 8.42729 94.4313 23L91.6669 46.5166C91.6669 47.6429 90.7454 48.5643 89.6191 48.5643H64.8649C52.9883 48.5643 44.2629 47.2106 38.6887 44.5145C33.1144 41.8183 30.3272 37.2338 30.3272 30.7494C30.3272 19.6009 35.5488 12.3089 45.9807 8.89606C56.4125 5.48325 70.9852 3.59483 89.6874 3.2308Z",
    fill: "url(#paint0_linear_46_34)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_34",
    x1: 65.1038,
    y1: 5.07371,
    x2: 100.847,
    y2: 63.2849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC31F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0AAAB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2584BF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.186611bde626fab59893b7db859a5771.svg";
export { ForwardRef as ReactComponent };